import { isBrowser } from '@app/utils/isBrowser'

declare global {
  interface Window {
    gtag: any
  }
}

const reportConversion = (sendTo: string): void => {
  if (!isBrowser || !window.gtag) return

  window.gtag('event', 'conversion', {
    send_to: sendTo
  })
}

export const zipCode = (): void => {
  reportConversion(events.ZIP_CODE)
}

export const age9AndLess = (): void => {
  reportConversion(events.AGE_0_TO_9)
}

export const age10AndMore = (): void => {
  reportConversion(events.AGE_10_AND_MORE)
}

export const diagnosisYes = (): void => {
  reportConversion(events.DIAGNOSIS_YES)
}

export const diagnosisNo = (): void => {
  reportConversion(events.DIAGNOSIS_NO_OR_UNKNOWN)
}

export const insuranceYes = (): void => {
  reportConversion(events.INSURANCE_YES)
}

export const insuranceNo = (): void => {
  reportConversion(events.INSURANCE_NO)
}

export const personalInfoSubmitted = (): void => {
  reportConversion(events.PERSONAL_INFO_AND_IS_ELIGIBLE)
}

const events = {
  // booking
  ZIP_CODE: 'AW-658106055/Bd00CPv2luwBEMfN57kC',
  AGE_0_TO_9: 'AW-658106055/ZefPCKyFqOwBEMfN57kC',
  AGE_10_AND_MORE: 'AW-658106055/G8kaCPGIqOwBEMfN57kC',
  DIAGNOSIS_YES: 'AW-658106055/AL8jCMbYuewBEMfN57kC',
  DIAGNOSIS_NO_OR_UNKNOWN: 'AW-658106055/Y8x4CJ2UqOwBEMfN57kC',
  INSURANCE_YES: 'AW-658106055/xoCdCP2Ay-wBEMfN57kC',
  INSURANCE_NO: 'AW-658106055/S8tnCIGIy-wBEMfN57kC',
  PERSONAL_INFO_AND_IS_ELIGIBLE: 'AW-658106055/m2MWCMOxqOwBEMfN57kC'
}
